export default __webpack_public_path__ + "static/media/plan-selected-success-fg.cf03519d.svg";